import PageShell from '../../components/feature/PageShell';
import PageHero from '../../components/feature/PageHero';
import AboutSection from '../home/components/AboutSection';
import ExperienceSection from '../home/components/ExperienceSection';

export default function NosotrosPage() {
  return (
    <PageShell>
      {() => (
        <>
          <PageHero
            title="Sobre"
            highlight="Nosotros"
            subtitle="¿Quiénes somos?"
            bgImage="https://readdy.ai/api/search-image?query=modern%20premium%20dental%20clinic%20interior%20professional%20team%20dentists%20white%20coats%20elegant%20office%20blue%20white%20color%20scheme%20clean%20medical%20environment%20professional%20staff%20bright%20lighting&width=1920&height=600&seq=nosotros-hero-001&orientation=landscape"
            breadcrumbs={[
              { label: 'Inicio', to: '/' },
              { label: 'Nosotros' },
            ]}
          />
          <AboutSection />
          <TeamSection />
          <ExperienceSection />
          <MissionSection />
        </>
      )}
    </PageShell>
  );
}

function TeamSection() {
  const team = [
    {
      name: 'Dra. M. Fernanda R.',
      role: 'Directora & Especialista en Rehabilitación',
      img: 'https://readdy.ai/api/search-image?query=female%20dentist%20doctor%20professional%20portrait%20white%20coat%20smiling%20confident%20clinic%20background%20modern%20dental%20office%20warm%20lighting%20professional%20headshot%20attractive&width=400&height=480&seq=team-mf-001&orientation=portrait',
      spec: 'Rehabilitación Oral · Prótesis · Implantología',
      icon: 'ri-award-line',
    },
    {
      name: 'Dr. Alejandro Morales',
      role: 'Cirujano Maxilofacial',
      img: 'https://readdy.ai/api/search-image?query=male%20dentist%20surgeon%20doctor%20professional%20portrait%20white%20coat%20glasses%20smiling%20confident%20dental%20clinic%20background%20modern%20professional%20headshot%20friendly&width=400&height=480&seq=team-am-002&orientation=portrait',
      spec: 'Cirugía · Extracciones · Implantes',
      icon: 'ri-surgical-mask-line',
    },
    {
      name: 'Dra. Sofía Vargas',
      role: 'Especialista en Ortodoncia',
      img: 'https://readdy.ai/api/search-image?query=young%20female%20dentist%20orthodontist%20professional%20portrait%20white%20coat%20smiling%20happy%20dental%20clinic%20bright%20clean%20background%20professional%20headshot%20warm&width=400&height=480&seq=team-sv-003&orientation=portrait',
      spec: 'Ortodoncia · Alineadores · Retención',
      icon: 'ri-align-justify',
    },
  ];

  return (
    <section className="py-28 bg-[#f7f9fc]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 scroll-animate">
          <span className="inline-block text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-3">
            Nuestro equipo
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0A2540] mb-5">
            Especialistas{' '}
            <span className="bg-gradient-to-r from-[#3A86FF] to-[#0A2540] bg-clip-text text-transparent">
              Certificados
            </span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto font-light">
            Nuestro equipo cuenta con formación especializada, actualización continua y un compromiso total con tu salud bucal.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {team.map((member, i) => (
            <div
              key={member.name}
              className={`group bg-white rounded-3xl overflow-hidden border border-gray-100 hover:-translate-y-2 transition-all duration-300 scroll-animate anim-delay-${i * 100}`}
            >
              <div className="relative overflow-hidden" style={{ height: '300px' }}>
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A2540]/70 to-transparent" />
                <div className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-[#3A86FF]/20 backdrop-blur-sm rounded-xl border border-[#3A86FF]/30">
                  <i className={`${member.icon} text-[#3A86FF]`} />
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-bold text-[#0A2540] text-lg">{member.name}</h3>
                <p className="text-[#3A86FF] text-sm font-medium mt-1">{member.role}</p>
                <p className="text-gray-400 text-xs mt-3 leading-relaxed">{member.spec}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function MissionSection() {
  const items = [
    {
      icon: 'ri-focus-2-line',
      label: 'Misión',
      text: 'Brindar atención odontológica integral de la más alta calidad, con un trato cálido y personalizado, utilizando tecnología de vanguardia para mejorar la salud y calidad de vida de nuestros pacientes.',
      color: 'from-[#3A86FF]/15 to-[#0A2540]/10',
      iconColor: 'text-[#3A86FF]',
    },
    {
      icon: 'ri-eye-line',
      label: 'Visión',
      text: 'Ser una clínica dental referente en Ciudad de México, reconocida por la excelencia clínica, innovación tecnológica y el trato humano que transforma la vida de nuestros pacientes a través de su sonrisa.',
      color: 'from-emerald-500/15 to-emerald-900/10',
      iconColor: 'text-emerald-500',
    },
    {
      icon: 'ri-shield-star-line',
      label: 'Valores',
      text: 'Profesionalismo, empatía, integridad y compromiso con la excelencia. Creemos que cada paciente merece lo mejor, y trabajamos cada día para superar sus expectativas.',
      color: 'from-amber-500/15 to-amber-900/10',
      iconColor: 'text-amber-500',
    },
  ];

  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 scroll-animate">
          <span className="inline-block text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-3">
            Nuestra identidad
          </span>
          <h2 className="text-4xl font-extrabold text-[#0A2540]">
            Misión, Visión &{' '}
            <span className="bg-gradient-to-r from-[#3A86FF] to-[#0A2540] bg-clip-text text-transparent">Valores</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {items.map((item, i) => (
            <div
              key={item.label}
              className={`rounded-3xl p-8 bg-gradient-to-br ${item.color} border border-gray-100 scroll-animate anim-delay-${i * 100}`}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-white rounded-2xl mb-6 border border-gray-100">
                <i className={`${item.icon} ${item.iconColor} text-2xl`} />
              </div>
              <h3 className="font-bold text-[#0A2540] text-xl mb-4">{item.label}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
